module.exports = "/_next/static/images/onboard-payroll-2-1863a43261c952d5b102a5f962b74e40.svg";